import {
    FilterLabels,
    FilterPills,
    filterMapper,
} from 'components/common/GlobalFilterComponent/GlobalFilterComponent.utils';
import { Pills } from 'components/common/pills/pills';

import classes from 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetPills/PinboardWidgetPills.module.scss';
import { IWidgetFilters } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

const maxLength = 10;
/**
 * Dashboard Widget Filters (only view mode).
 * @param {string}  widgetId - unique ID created when adding a new widget to a specific pinboard.
 * @param {IFilterLegacy[]}  filters - list of filters used in the API for fetching data.
 * @returns Widget Filters JSX Component using Pills
 * */
export const PinboardWidgetPills = ({ filters }: IWidgetFilters) => {
    return (
        <div data-testid={'widget-filters-container'} className={classes.widgetFiltersContainer}>
            {filters.map((filter) => {
                const name = filter.name;
                const data = filter.data || [];
                if (data.length === 0) return null;
                return (
                    <div data-testid={'filters-container'} key={name} className={classes.filtersContainer}>
                        <span className={classes.title}>{FilterLabels[name] || name}:</span>
                        <span className={classes.value}>
                            {data.slice(0, maxLength).map((item: string | number) => {
                                return (
                                    <Pills key={`filters-value-${name}-${item}`} className={classes.pill}>
                                        {typeof item === 'string' ? FilterPills[filterMapper(item)] || item : item}
                                    </Pills>
                                );
                            })}
                            <div className={classes.more} title={name}>
                                {data.length > maxLength && `& ${data.length - maxLength} more...`}
                            </div>
                        </span>
                    </div>
                );
            })}
        </div>
    );
};
